import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import { getError } from '@/utils/hookFormUtils';

import type { UseFormRegister, UseFormWatch } from 'react-hook-form';

interface DirectionDataProps {
  label: string;
  name: string;
}

interface DirectionFormProps {
  register: UseFormRegister<any>;
  errors: any;
  directionData: DirectionDataProps[];
  watch?: UseFormWatch<any>;
}

const DirectionForm = ({ register, errors, directionData, watch }: DirectionFormProps) => {
  return (
    <Grid container size={{ xxs: 12 }} spacing={1}>
      {directionData.map((data, index) => {
        const error = getError(errors, data.name);
        const fieldValue = watch ? watch(data.name) : undefined;

        return (
          <Grid size={{ xxs: index === 1 || index === 2 ? 6 : 12 }} key={data.name}>
            <TextField
              {...register(data.name)}
              value={fieldValue !== undefined ? fieldValue || '' : undefined}
              size="small"
              variant="outlined"
              fullWidth
              label={data.label}
              error={!!error}
              helperText={error?.message ? String(error.message) : undefined}
              slotProps={{
                inputLabel: {
                  shrink: fieldValue !== undefined ? Boolean(fieldValue) || undefined : undefined,
                },
                htmlInput: {
                  autoComplete: 'off',
                  role: 'presentation',
                  'data-form-type': 'other',
                  'data-lpignore': 'true',
                  'data-1p-ignore': 'true',
                },
              }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default DirectionForm;
